import { DropdownMenuItemType } from "@fluentui/react/lib/Dropdown";

export class DropdownOption {
	constructor(public key: string | number, public text: string, public itemType?: DropdownMenuItemType, public disabled?: boolean) {}
}